export enum NightMode {
  ON = "ON",
  OFF = "OFF",
}

export enum PictureBackground {
  ON = "ON",
  OFF = "OFF",
}

export enum Theme {
  THEME_BLUE = "THEME-BLUE",
  THEME_RED = "THEME-RED",
  THEME_GREEN = "THEME-GREEN",
  THEME_PINK = "THEME-PINK",
  THEME_GINGER = "THEME-GINGER",
}

export interface ThemeObj {
  id: Theme;
  colorSample: string;
}

export const availableThemes: ThemeObj[] = [
  {
    id: Theme.THEME_BLUE,
    colorSample: "#196ac8",
  },
  {
    id: Theme.THEME_RED,
    colorSample: "#ba263f",
  },
  {
    id: Theme.THEME_GREEN,
    colorSample: "#36895f",
  },
  {
    id: Theme.THEME_PINK,
    colorSample: "#cf269c",
  },
  {
    id: Theme.THEME_GINGER,
    colorSample: "#c7451a",
  },
];

export enum ThemeVar {
  THEME_0 = "--theme-color-0",
  THEME_1 = "--theme-color-1",
  THEME_2 = "--theme-color-2",
  THEME_3 = "--theme-color-3",
  THEME_4 = "--theme-color-4",
  THEME_5 = "--theme-color-5",
  THEME_6 = "--theme-color-6",
  THEME_7 = "--theme-color-7",
  THEME_8 = "--theme-color-8",
  THEME_9 = "--theme-color-9",
  THEME_10 = "--theme-color-10",
  THEME_11 = "--theme-color-11",
  THEME_12 = "--theme-color-12",
  THEME_13 = "--theme-color-13",
  THEME_14 = "--theme-color-14",
  THEME_15 = "--theme-color-15",
  THEME_16 = "--theme-color-16",
  THEME_17 = "--theme-color-17",
  THEME_18 = "--theme-color-18",
  THEME_19 = "--theme-color-19",
  THEME_20 = "--theme-color-20",
  THEME_21 = "--theme-color-21",
  THEME_22 = "--theme-color-22",
  THEME_23 = "--theme-color-23",
  THEME_24 = "--theme-color-24",
}

export enum ResultVar {
  RESULT_20 = "--color-result-20",
  RESULT_40 = "--color-result-40",
  RESULT_60 = "--color-result-60",
  RESULT_80 = "--color-result-80",
  RESULT_100 = "--color-result-100",
}

export enum AppViewVar {
  VIEW_ERROR_NOTIFICATION_BACKGROUND_COLOR = "--error-notification-background-color",
  VIEW_OFFLINE_NOTIFICATION_BACKGROUND_COLOR = "--offline-notification-background-color",
}
